import { FunctionalComponent, h } from '@stencil/core';

export type HeaderBannerProps = {};

export const MessageBanner: FunctionalComponent<HeaderBannerProps> = (_props: HeaderBannerProps, children) => <div class="message-banner">{children}</div>;
